// 9th form
// registrationData has arrays names plant_info and machining_info
// like -
/*
   "plant_info": [
            {
                "location": "Bangalore, India",
                "plant_id": "PLANT_049ae3ea-8d12-4f6d-af4c-6010c5163951",
                "machine_ids": null,
                "plant_name": "Blue Horizon Plant",
                "type_of_plant": "Processing",
                "area_of_plant": "2500 sq ft",
                "number_of_machines": 30,
                "number_of_washrooms": 6,
                "number_of_staff_rooms": 3
            },
            {
                "location": "Chennai, India",
                "plant_id": "PLANT_8ae50af6-23ef-4199-b6c3-f05b731cfbed",
                "machine_ids": null,
                "plant_name": "Sunrise Plant",
                "type_of_plant": "Packaging",
                "area_of_plant": "1800 sq ft",
                "number_of_machines": 20,
                "number_of_washrooms": 3,
                "number_of_staff_rooms": 2
            },
    ]

    "machining_info":
      [
            {
                "automation": "Semi-Automatic",
                "machine_id": "MACHINE_8b2f9597-c7cc-4cc7-8fc3-92d0d53b9ff1",
                "plant_id": "PLANT_8ae50af6-23ef-4199-b6c3-f05b731cfbed",
                "machine_name": "Haas VF-4SS Updated",
                "plant_name": "Sunrise Plant",
                "make_and_model": "Haas VF-4SS",
                "types_of_machine": "Vertical Machining Center",
                "machine_capacity": "12000",
                "last_calibrated_on": "2024-10-20",
                "table_size": "50x20 inches",
                "up_time": "20 hours per day",
                "age_of_machine": "5 years",
                "maintenance_cycle": "Monthly",
                "number_of_skilled_operators": 3,
                "acceptance_rate": "2%",
                "document_ids": []
            },
            {
                "automation": "Semi-Automatic",
                "machine_id": "MACHINE_45095bb9-7583-4ee6-bc17-7b0cfee93700",
                "plant_id": "PLANT_8ae50af6-23ef-4199-b6c3-f05b731cfbed",
                "machine_name": "Haas VF-4SS",
                "plant_name": "Sunrise Plant",
                "make_and_model": "Haas VF-4SS",
                "types_of_machine": "Vertical Machining Center",
                "machine_capacity": "12000",
                "last_calibrated_on": "2024-01-20",
                "table_size": "50x40 inches",
                "up_time": "20 hours per day",
                "age_of_machine": "5 years",
                "maintenance_cycle": "Monthly",
                "number_of_skilled_operators": 3,
                "acceptance_rate": "2%",
                "document_ids": []
            },
      ]
  */
import React from 'react';
import no_plant1 from '@/js/images/no_plants1.svg';
import defaultImage from '@/js/images/Factory.svg';
import { useDispatch, useSelector } from 'react-redux';
import noData1 from '@/js/images/no-data.svg';
import noData2 from '@/js/images/nodata.svg';
import noData3 from '@/js/images/nodata3.svg';
import noData4 from '@/js/images/nodata4.svg';
import noData5 from '@/js/images/nodata5.svg';
import { useState, useEffect, useMemo } from 'react';
import { Edit2, Plus } from 'lucide-react';
import createApiClient from '@/api/axiosInstance';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
// pick random image from noData1-4 for no data
const randomImages = [noData1, noData2, noData3, noData4, noData5];
const randomTexts = [
  'Oops! No such data in sight!',
  'Awkward! We found nothing!',
  "Umm, it seems you don't have this plant!",
  'Uh-oh! No findings here!',
  "Nuh-uh! There's such plant!",
];

const PlantInfromation = ({ setSectionId }) => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, []);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const reduxData = useSelector(
    (state) => state?.authReducer?.registrationData,
  );
  const token = useSelector((state) => state.authReducer.token);

  const [localPlantInfo, setLocalPlantInfo] = useState(
    reduxData?.plant_info || [],
  );
  const [localMachineInfo, setLocalMachineInfo] = useState(
    reduxData?.machining_info || [],
  );
  // To Sync the local state with redux state
  useEffect(() => {
    if (reduxData?.plant_info) {
      setLocalPlantInfo(reduxData.plant_info);
    }
    if (reduxData?.machining_info) {
      setLocalMachineInfo(reduxData.machining_info);
    }
  }, [reduxData]);

  const [searchTerm, setSearchTerm] = useState('');
  const [randomNoData, setRandomNoData] = useState({
    image: randomImages[0],
    text: randomTexts[0],
  });
  const [noDataInitialized, setNoDataInitialized] = useState(false);

  const filteredPlants = useMemo(() => {
    const term = searchTerm.trim();
    const lowerTerm = term.toLowerCase();

    if (!term) {
      return localPlantInfo;
    }

    const nameMatches = [];
    const locationMatches = [];
    const areaMatches = [];

    // Check if the term is a pure number
    const isPureNumber = /^\d+$/.test(term);
    const searchNumber = isPureNumber ? parseInt(term, 10) : NaN;

    // More defensive version for getting area value
    const getAreaValue = (areaString) => {
      try {
        if (typeof areaString !== 'string') {
          if (typeof areaString === 'number') return areaString;
          areaString = String(areaString);
        }
        return parseInt(areaString.replace(/[^0-9]/g, ''), 10) || 0;
      } catch (error) {
        console.warn('Error parsing area value:', error);
        return 0; // Return a default value
      }
    };

    localPlantInfo.forEach((plant) => {
      const nameMatch = plant.plant_name.toLowerCase().includes(lowerTerm);
      const locationMatch = plant.location.toLowerCase().includes(lowerTerm);

      // Always prioritize name matches (even if the term is a number)
      if (nameMatch) {
        nameMatches.push(plant);
      } else if (locationMatch) {
        locationMatches.push(plant);
      }
      // Only consider area matches if the term is a pure number
      else if (isPureNumber && plant.area_of_plant) {
        const plantArea = getAreaValue(plant.area_of_plant);
        // Only match if plant area is greater than or equal to search number
        if (plantArea >= searchNumber) {
          areaMatches.push({ plant, areaValue: plantArea });
        }
      }
    });

    // Sort area matches by area (ascending)
    const sortedAreaMatches = areaMatches
      .sort((a, b) => a.areaValue - b.areaValue)
      .map((entry) => entry.plant);

    return [...nameMatches, ...locationMatches, ...sortedAreaMatches];
  }, [searchTerm, localPlantInfo]);

  useEffect(() => {
    if (filteredPlants.length === 0 && !noDataInitialized) {
      const randomIndex = Math.floor(Math.random() * randomImages.length);
      setRandomNoData({
        image: randomImages[randomIndex],
        text: randomTexts[randomIndex],
      });
      setNoDataInitialized(true);
    } else if (filteredPlants.length > 0) {
      setNoDataInitialized(false);
    }
  }, [filteredPlants, noDataInitialized]);

  return (
    <div className="w-full font-roboto h-full flex flex-col items-center justify-center">
      {localPlantInfo.length > 0 ? (
        <>
          <div className="max-w-6xl justify-between h-12 w-full px-8 font-semibold flex mb-6 items-center">
            <span className="text-2xl text-gray-600">
              {filteredPlants.length}{' '}
              {filteredPlants.length === 1 ? 'Result' : 'Results'}
            </span>
            <div className="relative flex">
              <input
                type="text"
                placeholder=" Search"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="focus:ring-0 font-normal focus:ring-offset-0 focus-visible:ring-0 focus-visible:ring-offset-0 focus-visible:outline-none focus:outline-none focus:border-lightPurple/60 px-5 py-2 rounded-md mr-3 h-10 border w-72"
              />
              <button
                onClick={() => setSectionId(8)}
                className="px-5 flex py-2 bg-lightPurple  border border-lightPurple h-10 text-white ease-in duration-100 text-base font-normal rounded-md  hover:text-darkerPurple hover:bg-white"
              >
                <Plus size={20} className="mr-2 translate-y-0.5" />
                Add
              </button>
            </div>
          </div>
          {filteredPlants.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-7 pt-4 px-2 w-full">
              {filteredPlants.map((plant) => (
                <div
                  key={plant?.plant_id}
                  className="bg-white border shadow-md rounded-md p-4 w-full max-w-[390px] border-lightPurple/30"
                >
                  {console.log(filteredPlants, 'filteredPlants')}

                  <img
                    src={defaultImage}
                    alt="default Plant"
                    className="max-w-96 bg-gray-100 rounded-md max-h-56 mb-2 w-full object-cover"
                  />

                  <h2 className="text-xl font-semibold text-gray-700 mb-2">
                    {plant?.plant_name}
                  </h2>

                  <p className="text-gray-600">
                    <span className="font-medium">Area: </span>
                    {plant?.area_of_plant} sq. ft.
                  </p>

                  <p className="text-gray-600 truncate w-full">
                    <span className="font-medium">Location: </span>
                    {plant?.location}
                  </p>

                  <Button
                    type="button"
                    className="mt-3 font-semibold flex w-full h-9 items-center px-5 py-2 text-sm bg-white border border-lightPurple text-lightPurple rounded-md hover:bg-lightPurple/95 hover:text-white transition-colors group"
                    onClick={() => setSectionId(8, plant?.plant_id)}
                  >
                    <Edit2
                      size={20}
                      className="transition-transform duration-200 group-hover:rotate-360 cursor-pointer"
                    />
                    Edit
                  </Button>
                </div>
              ))}
            </div>
          ) : (
            <div className="py-16 flex flex-col items-center justify-center">
              <h1 className="text-2xl font-semibold text-gray-600 mb-6">
                {randomNoData.text}
              </h1>
              <img src={randomNoData.image} alt="No Data Found" width={300} />
            </div>
          )}
        </>
      ) : (
        <div className="py-16">
          <h1 className="text-3xl font-semibold text-gray-600 text-center mb-2">
            No Manufacturing Plants Added
          </h1>
          <p className="text-gray-500 text-md  text-center">
            Your industrial network starts here!
          </p>
          <p className="text-gray-500 text-md mb-5 -translate-y-0.5  text-center">
            Add details about your plants to track & manage your operations
            efficiently.
          </p>
          <img src={no_plant1} width={600} alt="no plant" />
          <div className="flex mt-6 justify-center items-center">
            <button
              className="mt-2 flex px-5 py-2 text-md bg-lightPurple border border-darkPurple text-white rounded-md hover:bg-white hover:text-darkerPurple transition-colors"
              onClick={() => setSectionId(8)}
            >
              <Plus size={20} className="mr-2 translate-y-0.5" />
              Add First Facility
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default PlantInfromation;
